// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"z3-z"};